export function formatAmount(value, symbol) {
  if (value == null || value === "") return "-";
  const text = String(value).trim();
  if (!text) return "-";
  if (!/^-?\d+(\.\d+)?$/.test(text)) return String(value);

  const negative = text.startsWith("-");
  const unsigned = negative ? text.slice(1) : text;
  const [intRaw, fracRaw = ""] = unsigned.split(".");
  const intPart = intRaw.replace(/^0+(?=\d)/, "") || "0";
  const fracPart = fracRaw.slice(0, 6).replace(/0+$/, "");
  const compact = `${negative ? "-" : ""}${intPart}${fracPart ? `.${fracPart}` : ""}`;

  return `${compact} ${symbol || "BNB"}`;
}

function parseDateTime(value) {
  if (value == null || value === "") return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const asMs = value > 1e12 ? value : value * 1000;
    const date = new Date(asMs);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const text = String(value).trim();
  if (!text) return null;

  if (/^\d+$/.test(text)) {
    const num = Number(text);
    const asMs = num > 1e12 ? num : num * 1000;
    const date = new Date(asMs);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  // MySQL datetime fallback from legacy responses, assume UTC.
  const mysqlLike = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
  const normalized = mysqlLike.test(text) ? `${text.replace(" ", "T")}Z` : text;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(value) {
  const date = parseDateTime(value);
  if (!date) return "-";
  // Render in browser local timezone for user-friendly display.
  return date.toLocaleString(undefined, { hour12: false });
}
